module.exports = "<gw-definition-list title=\"{{ $ctrl.roleName }}\">\r\n</gw-definition-list>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/roles/ContactRoleDefault/ContactRoleDefault.html
// module id = 701
// module chunks = 0